module.exports = __webpack_public_path__ + "img/finland-blood-diseases-female.652af03c.png";